import { Box, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { Select } from "chakra-react-select";

import { AvDatePicker } from "~/components/AvDatePicker";
import Meta from "~/layout/Meta";
import { withRenderTally } from "~/utils/withRenderTally";

const DemoItem = ({ label, children }: { label: string; children: React.ReactNode }) => {
  return (
    <Box>
      <Text fontSize="md" fontWeight="bold">
        {label}
      </Text>
      {children}
    </Box>
  );
};

const DemoPageComponent = () => {
  return (
    <>
      <Meta title="Demo Page" />
      <Flex align={["top", "top"]}>
        <VStack align="flex-start">
          <Heading as="h1">Demo Page</Heading>
          <VStack spacing={4} pt={4} align="flex-start">
            <DemoItem label="Date Picker">
              <AvDatePicker selectedDate={new Date()} onChange={() => {}} />
            </DemoItem>
            <DemoItem label="Select">
              <Select
                options={[
                  {
                    label: "I am red",
                    value: "i-am-red",
                    colorScheme: "red"
                  },
                  {
                    label: "I am blue",
                    value: "i-am-blue",
                    colorScheme: "blue"
                  },
                  {
                    label: "I fallback to purple",
                    value: "i-am-purple"
                  }
                ]}
              />
            </DemoItem>
          </VStack>
        </VStack>
      </Flex>
    </>
  );
};

// Export the component with render tallying
const DemoPage = withRenderTally(DemoPageComponent, "DemoPage");
export default DemoPage;
